

















































import Vue, { PropType } from 'vue'

export default Vue.extend({
  name: 'DialogSummary',

  props: {
    dialogSummary: Boolean,
    score: Number,
  },

  methods: {
    updateRecord(): void {
      let currentRecord = Number(localStorage.getItem('record'))
      if (currentRecord == null || this.score < currentRecord) {
        localStorage.setItem('record', String(this.score))
      }
    },

    playAgain(): void {
      this.$emit('playAgain')
    },      
  },

  watch: {
    dialogSummary: function(newVal: boolean, oldVal: boolean) {
      if (newVal === true) {
        this.updateRecord()
      }
    }
  },
})
